var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("悠遊付付款說明")]),_c('ul',{staticClass:"has-type-decimal"},[_c('li',[_vm._v("使用悠遊付恕不適用分期付款。")]),_c('li',[_vm._v("悠遊付限使用信用卡付款")]),_c('li',[_vm._v("於訂單成立後 20 分鐘內須完成付款")]),_c('li',[_vm._v("付款額度限制：單月 30 萬。")])])])
}]

export { render, staticRenderFns }